
<div *ngIf="isSubjectPopupVisible" class="popup card p-5">    
    <div class="popup-container container w-100">
        <div class="">
            <h5 class="text-center d-block" [style]="style.color">Select Subject Combination</h5>
            <p class="text-center d-block">Maximum number of Subject Combination: {{user.maxCombo}}</p>
        </div>
        
        <div class="row p-5">
            <div [ngClass]="{'bg-success': isSubjectSelected(subject)}" class="col-md-6  col-12 py-2 my-1 card text-center" (click)="addOrRemoveSelectedSubjects(subject)"
                *ngFor="let subject of domainSubjects">{{subject}}</div>
        </div>  
        
    </div>
    <div class="d-flex justify-content-center align-items-center">
        <button [style]="style.btnstyle" class="p-3" 
            (click)="submitSelection()" [disabled]="selectedSubject.length !== user.maxCombo">
            Submit
        </button>
        <button  *ngIf="dismissable" [style]="style.btnstyle" class="p-3" 
            (click)="close()">
            Cancel
        </button>
    </div>
    
</div>
<div *ngIf="isSubjectPopupVisible" class="overlay">
    
</div>